
import "./Button.css"

const ButtonField =( {text})=>{
    return(
        <button className ="button" >
         {text}
        </button>
    )
}
export default ButtonField;